// const dotenv = require('dotenv');
// import dotenv from "dotenv";
import { loadStripe } from "@stripe/stripe-js"

// Turn all letter to lowercase and replace all spaces to "-", use at creating url paths
export const nameToPathConvert = (name: string) => {
    return name.toLowerCase().replace(" ", "-");
};

declare const Stripe: any;

let stripePromise:any;
const getStripe = (pKey:string) => {
  if (!stripePromise) {
    stripePromise = loadStripe(pKey)
  }
  return stripePromise
}

export const checkout = async (scheme: "plan" | "sku", schemeId: string) => {
    // const env = "test";
    const env:any = "live";
    let stripeToken = ''

    if (env === "test") {
        stripeToken = process.env.GATSBY_STRIPE_LIVE_KEY || ''
    } else {
        stripeToken = process.env.GATSBY_STRIPE_TEST_KEY || ''
    }

    const stripe = await getStripe(stripeToken)
    console.log(stripe);
    await stripe
        .redirectToCheckout({
            items: [{ [scheme]: schemeId, quantity: 1 }],

            // Do not rely on the redirect to the successUrl for fulfilling
            // purchases, customers may not always reach the success_url after
            // a successful payment.
            // Instead use one of the strategies described in
            // https://stripe.com/docs/payments/checkout/fulfillment
            // successUrl: "https://josephine-react.netlify.com/orderSuccess",
            // cancelUrl: "https://josephine-react.netlify.com/orderFailed"
            // successUrl: "https://centreo.hk/",
            // cancelUrl: "https://centreo.hk/"
            successUrl: "https://dev.centreo.hk/",
            cancelUrl: "https://dev.centreo.hk/"
        })
        .then((result: string) => {
            // tslint:disable-next-line: no-console
            console.log(result);
        });
};

export const getService = (ev: any) => {
    const schemeId = ev.target.dataset.schemeid
    const scheme = ev.target.dataset.scheme
    checkout(scheme, schemeId);
};